// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a3cfaac9","455":"43dac921","488":"2863c901","977":"e2dabe58"}[chunkId] + ".chunk.js";
};